import { authApi, formData } from "utils";


export const savePersonal = (data) => () =>
    authApi.post(`/settings/user/personal_details`, formData(data)).then(res => {
      if (res.status === 200) {
        return res
      } else {
        throw res
      }
    }).catch(err => {
      throw err
    })

export const createOnFidoToken = (application_id) => () =>
    authApi.post(`/onfido/token/create`, formData({ application_id })).then(res => {
      if (res.status === 200) {
        return res
      } else {
        throw res
      }
    }).catch(err => {
      throw err
    });


export const checkOnFido = (application_id) => () =>
    authApi.post(`/onfido/check/create`, formData({ application_id })).then(res => {
      if (res.status === 200) {
        return res
      } else {
        throw res
      }
    }).catch(err => {
      throw err
    });

export const recreateOnFidoToken = (application_id) => () =>
    authApi.post(`/onfido/application/create`, formData({ application_id })).then(res => {
      if (res.status === 200) {
        return res
      } else {
        throw res
      }
    }).catch(err => {
      throw err
    })
